<template>
  <pt-video-manage class="pt-video-manage__page"></pt-video-manage>
</template>

<script>
import PtVideoManage from 'cps/tool-operation/pt-video-manage/withData'
export default {
  name: 'pt-video-manage__view',
  components: {
    'pt-video-manage': PtVideoManage
  }
}
</script>
